import client from './client'

export async function fetchTestimonials() {
  return client.get('/testimonials')
}
